import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import { useAppContext } from '../../../../../redux/slices/appContext'

function AppContextFieldEditor ({ field, control }) {
  const appContext = useAppContext()
  const contextValue = appContext[field.value]

  return (
    <Controller
      name={field.id}
      control={control}
      defaultValue={contextValue}
      render={() => null}
    />
  )
}

AppContextFieldEditor.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }).isRequired,
  control: PropTypes.object.isRequired
}

export default AppContextFieldEditor
